import { useState, useEffect, useRef, useContext } from "react";
import axios from "axios";
import moment from "moment-timezone";
import Flatpickr from "react-flatpickr";
import Header from "../layout/Header";
import Footer from "../layout/Footer";
import Loader from "../layout/Loader";
import { alertContext } from "../contexts/AlertProvider";
import TruncatedTd from "../layout/TruncatedTd";
import Alert from "../Alert";
import Pagination from "../layout/Pagination";
import PermissionGate from "../layout/PermissionGate";

const AllNotifications = () => {
  const [data, setData] = useState([]);
  const [modal, setModal] = useState({ open: false, action: "", data: "" });
  const [error, setError] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");
  const [search, setSearch] = useState("");
  const [alertConfig, setAlertConfig] = useContext(alertContext);
  const dateRangePickerRef = useRef(null);
  const token = localStorage.getItem("token");
  const limit = process.env.REACT_APP_PAGINATION_LIMIT;

  const fetchNotifications = () => {
    axios
      .get(
        `${process.env.REACT_APP_API_ENDPOINT}notification/get?page=${page}&limit=${limit}&startDate=${start}&endDate=${end}&search=${search}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        if (res.data.code === 1) {
          if (page > 1) {
            if (res.data.data.length === 0) {
              setPage(page - 1);
            } else {
              setData(res.data.data);
              setCount(res.data.count);
              setIsLoading(false);
            }
          } else {
            setData(res.data.data);
            setCount(res.data.count);
            setIsLoading(false);
          }
        } else {
          setIsLoading(false);
        }
      })
      .catch(console.error);
  };
  const addNotification = () => {
    if (
      modal?.data?.content &&
      modal?.data?.content !== undefined &&
      modal?.data?.content !== null &&
      modal?.data?.content !== ""
    ) {
      setError({ ...error, content: "" });
      setIsLoading(true);
      axios
        .post(
          process.env.REACT_APP_API_ENDPOINT + "notification/create",
          { content: modal?.data?.content },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((res) => {
          if (res) {
            setIsLoading(false);
            if (res.data.code === 1) {
              reset();
              fetchNotifications();
              setAlertConfig({
                show: true,
                message: res.data.message,
                type: "success",
              });
            }
          }
        })
        .catch(console.error);
    } else {
      setError({ ...error, content: "Please enter notification content" });
    }
  };
  const editNotification = () => {
    if (
      modal?.data?.content &&
      modal?.data?.content !== undefined &&
      modal?.data?.content !== null &&
      modal?.data?.content !== "" &&
      modal?.data?._id &&
      modal?.data?._id !== undefined &&
      modal?.data?._id !== null &&
      modal?.data?._id !== ""
    ) {
      setError({ ...error, content: "" });
      setIsLoading(true);
      axios
        .put(
          `${process.env.REACT_APP_API_ENDPOINT}notification/edit/${modal?.data?._id}`,
          { content: modal?.data?.content },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((res) => {
          if (res) {
            setIsLoading(false);
            if (res.data.code === 1) {
              reset();
              fetchNotifications();
              setAlertConfig({
                show: true,
                message: res.data.message,
                type: "success",
              });
            }
          }
        })
        .catch(console.error);
    } else {
      setError({ ...error, content: "Please enter notification content" });
    }
  };
  const deleteNotification = () => {
    if (
      modal?.data?._id &&
      modal?.data?._id !== undefined &&
      modal?.data?._id !== null &&
      modal?.data?._id !== ""
    ) {
      setIsLoading(true);
      axios
        .delete(
          `${process.env.REACT_APP_API_ENDPOINT}notification/delete/${modal?.data?._id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((res) => {
          if (res) {
            setIsLoading(false);
            if (res.data.code === 1) {
              reset();
              fetchNotifications();
              setAlertConfig({
                show: true,
                message: res.data.message,
                type: "success",
              });
            }
          }
        })
        .catch(console.error);
    }
  };
  const markActive = () => {
    if (
      modal?.data?._id &&
      modal?.data?._id !== undefined &&
      modal?.data?._id !== null &&
      modal?.data?._id !== ""
    ) {
      setIsLoading(true);
      axios
        .patch(
          `${process.env.REACT_APP_API_ENDPOINT}notification/mark-active/${modal?.data?._id}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((res) => {
          if (res) {
            setIsLoading(false);
            if (res.data.code === 1) {
              reset();
              fetchNotifications();
              setAlertConfig({
                show: true,
                message: res.data.message,
                type: "success",
              });
            }
          }
        })
        .catch(console.error);
    }
  };
  const markInactive = () => {
    if (
      modal?.data?._id &&
      modal?.data?._id !== undefined &&
      modal?.data?._id !== null &&
      modal?.data?._id !== ""
    ) {
      setIsLoading(true);
      axios
        .patch(
          `${process.env.REACT_APP_API_ENDPOINT}notification/mark-inactive/${modal?.data?._id}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((res) => {
          if (res) {
            setIsLoading(false);
            if (res.data.code === 1) {
              reset();
              fetchNotifications();
              setAlertConfig({
                show: true,
                message: res.data.message,
                type: "success",
              });
            }
          }
        })
        .catch(console.error);
    }
  };
  const reset = () => {
    setPage(1);
    setSearch("");
    setStart("");
    setEnd("");
    setModal({ open: true, action: "", data: "" });
  };
  const openCalendar = () => {
    if (dateRangePickerRef.current) {
      dateRangePickerRef.current.flatpickr.open();
    }
  };
  useEffect(() => {
    fetchNotifications();
  }, [page, start, end, search]);

  return isLoading === true ? (
    <Loader />
  ) : (
    <div className="d-flex flex-column flex-root">
      <Alert />
      {/*begin::Page*/}
      <div className="page d-flex flex-row flex-column-fluid">
        {/*begin::Wrapper*/}
        <div
          className="wrapper d-flex flex-column flex-row-fluid"
          id="kt_wrapper"
        >
          <Header />
          <div className="app-body">
            <div className="toolbar py-3 py-lg-6" id="kt_toolbar">
              {/*begin::Container*/}
              <div
                id="kt_toolbar_container"
                className="container-xxl d-flex justify-content-between"
              >
                {/*begin::Page title*/}
                <div className="d-flex justify-content-between py-2 py-lg-0 gap-2 w-100">
                  <div>
                    {/*begin::Title*/}
                    <h1 className="d-flex text-dark fw-bold m-0 fs-3">
                      Notification List
                    </h1>
                    {/*end::Title*/}
                  </div>
                  <div>
                    <PermissionGate
                      required={`create_merchant_notifications`}
                      fallback={<></>}
                    >
                      <button
                        onClick={() =>
                          setModal({ open: true, action: "add", data: "" })
                        }
                        className="btn btn-success"
                      >
                        New Notification
                      </button>
                    </PermissionGate>
                  </div>
                </div>
                {/*end::Page title*/}
                {/*begin::Button*/}

                {/*end::Button*/}
              </div>
              {/*end::Container*/}
            </div>
            {/*end::Toolbar*/}

            {/*begin::Container*/}
            <div
              id="kt_content_container"
              className="d-flex flex-column-fluid align-items-start container-xxl"
            >
              {/*begin::Post*/}
              <div className="content flex-row-fluid" id="kt_content">
                {/*begin::Card*/}
                <PermissionGate required={`view_merchant_notifications`}>
                  <div className="card">
                    {/*begin::Card header*/}
                    <div className="card-header border-0 pt-6">
                      {/*begin::Card title*/}
                      <div className="row w-100">
                        <div className="col-md-6 text-start mb-3">
                          <input
                            type="text"
                            value={search}
                            autoComplete="off"
                            onChange={(e) => {
                              setSearch(e.target.value);
                            }}
                            className="form-control"
                            placeholder="Search by notification content"
                          />
                        </div>
                        <div className="col-md-6 text-end mb-3">
                          <div className="d-flex gap-2 justify-content-end">
                            <div className="d-flex position-relative">
                              <Flatpickr
                                ref={dateRangePickerRef}
                                value={
                                  start !== "" && end !== ""
                                    ? [new Date(start), new Date(end)]
                                    : null
                                }
                                options={{ dateFormat: "d-m-Y", mode: "range" }}
                                onChange={([start, end]) => {
                                  if (
                                    start !== undefined &&
                                    end !== undefined &&
                                    typeof start === "object" &&
                                    typeof end === "object"
                                  ) {
                                    setStart(
                                      moment(start).format("YYYY-MM-DD")
                                    );
                                    setEnd(moment(end).format("YYYY-MM-DD"));
                                  }
                                }}
                                className="form-control form-control-lg"
                                placeholder="Select Date"
                              />
                              <i
                                onClick={openCalendar}
                                className="bi-duotone bi-calendar fs-5 position-absolute"
                                style={{
                                  top: "28%",
                                  right: "5%",
                                  cursor: "pointer",
                                }}
                              ></i>
                            </div>
                            <button onClick={reset} className="btn btn-danger">
                              Reset
                            </button>
                          </div>
                        </div>
                      </div>
                      {/*begin::Card title*/}
                    </div>
                    {/*end::Card header*/}

                    {/*begin::Card body*/}
                    <div className="card-body py-4" id="filterDataWrap">
                      {/*begin::Table*/}
                      {data?.length === 0 ? (
                        <div className="text-center w-100">
                          <img
                            className="w-25 mx-auto py-20"
                            src={`${process.env.REACT_APP_PUBLIC_URL}assets/media/misc/no-content.png`}
                            alt="no-content"
                          />
                        </div>
                      ) : (
                        <div className="table-responsive">
                          <table className="table align-middle table-row-dashed fs-6 gy-5">
                            <thead>
                              <tr className="text-muted fw-bold fs-7 text-uppercase gs-0">
                                <th className="min-w-100px">Content</th>
                                <th className="text-center min-w-100px">
                                  Status
                                </th>
                                <th className="text-center min-w-100px">
                                  Date
                                </th>
                                <th className="text-center min-w-100px">
                                  Time
                                </th>
                                <th className="text-center min-w-100px">
                                  Actions
                                </th>
                              </tr>
                            </thead>
                            <tbody className="text-gray-600 fw-semibold">
                              {data &&
                                data?.map((item, index) => {
                                  return (
                                    <tr key={index}>
                                      <TruncatedTd length={100}>
                                        {item?.content}
                                      </TruncatedTd>
                                      <td className="text-center">
                                        <span
                                          className={
                                            item?.status === false
                                              ? "badge text-white bg-warning"
                                              : "badge text-white bg-success"
                                          }
                                        >
                                          {item?.status === false
                                            ? "Inactive"
                                            : "Active"}
                                        </span>
                                      </td>
                                      <td className="text-center">
                                        {moment(item?.createdAt)
                                          .tz(process.env.REACT_APP_TIMEZONE)
                                          .format("Do MMM, YYYY")}
                                      </td>
                                      <td className="text-center">
                                        {moment(item?.createdAt)
                                          .tz(process.env.REACT_APP_TIMEZONE)
                                          .format("hh:mm A")}
                                      </td>
                                      <td className="text-center">
                                        <div className="btn-group">
                                          {/*begin::Edit*/}
                                          <PermissionGate
                                            required={`edit_merchant_notifications`}
                                            fallback={<></>}
                                          >
                                            <button
                                              onClick={() => {
                                                setModal({
                                                  open: true,
                                                  action: "edit",
                                                  data: item,
                                                });
                                              }}
                                              className="btn px-2 btn-outline btn-primary btn-color-white btn-sm"
                                              title="Edit"
                                            >
                                              <i className="bi-duotone bi-pen fs-5"></i>
                                            </button>
                                          </PermissionGate>
                                          {/*end::Edit*/}

                                          {/*begin::Status*/}
                                          <PermissionGate
                                            required={
                                              item?.status === true
                                                ? `deactivate_merchant_notifications`
                                                : `activate_merchant_notifications`
                                            }
                                            fallback={<></>}
                                          >
                                            <span
                                              onClick={() => {
                                                setModal({
                                                  open: true,
                                                  data: item,
                                                  action:
                                                    item?.status === true
                                                      ? "markInactive"
                                                      : "markActive",
                                                });
                                              }}
                                              className={
                                                item?.status === true
                                                  ? "btn px-3 btn-outline btn-warning btn-color-white btn-sm"
                                                  : "btn px-3 btn-outline btn-success btn-color-white btn-sm"
                                              }
                                              title={
                                                item?.status === true
                                                  ? "Mark Inactive"
                                                  : "Mark Active"
                                              }
                                            >
                                              <i
                                                className={
                                                  item?.status === true
                                                    ? "bi-duotone bi-lock fs-5"
                                                    : "bi-duotone bi-unlock fs-5"
                                                }
                                              ></i>
                                            </span>
                                          </PermissionGate>
                                          {/*end::Status*/}
                                          {/*begin::Delete*/}
                                          <PermissionGate
                                            required={`delete_merchant_notifications`}
                                            fallback={<></>}
                                          >
                                            <span
                                              onClick={() => {
                                                setModal({
                                                  open: true,
                                                  action: "delete",
                                                  data: item,
                                                });
                                              }}
                                              className="btn px-3 btn-outline btn-danger btn-color-white btn-sm"
                                              title="Delete"
                                            >
                                              <i className="bi-duotone bi-trash fs-5"></i>
                                            </span>
                                          </PermissionGate>
                                          {/*end::Delete*/}
                                        </div>
                                      </td>
                                    </tr>
                                  );
                                })}
                            </tbody>
                          </table>
                        </div>
                      )}
                      {/*end::Table*/}
                      {/*begin::Paginate*/}
                      {count && Math.ceil(count / limit) > 1 ? (
                        <Pagination
                          page={page}
                          setPage={setPage}
                          count={count}
                          limit={limit}
                        />
                      ) : (
                        ""
                      )}
                      {/*end::Paginate*/}
                    </div>
                    {/*end::Card body*/}
                  </div>
                </PermissionGate>
                {/*end::Card*/}
              </div>
              {/*end::Post*/}
            </div>
          </div>
          {/*begin::Modal - Add Notification*/}
          <div
            className={
              modal?.open === true && modal?.action === "add"
                ? "modal fade show d-block"
                : "modal fade"
            }
            tabIndex="-1"
            id="addNotificationModal"
            aria-hidden="true"
          >
            {/*begin::Modal dialog*/}
            <div className="modal-dialog modal-dialog-centered">
              {/*begin::Modal content*/}
              <div className="modal-content rounded">
                {/*begin::Modal header*/}
                <div className="modal-header">
                  {/*begin::Close*/}
                  <h4>Add Notification</h4>
                  {/*end::Close*/}
                </div>
                {/*end::Modal header*/}

                {/*begin::Modal body*/}
                <div className="modal-body p-4">
                  <div className="row">
                    <div className="col-md-12">
                      <label className="form-label">Content</label>
                      <textarea
                        value={modal?.data?.content ?? ""}
                        onChange={(e) => {
                          setModal({
                            ...modal,
                            data: {
                              content: e.target.value,
                            },
                          });
                          setError({ ...error, content: "" });
                        }}
                        autoComplete="off"
                        className="form-control"
                        placeholder="Enter notification content"
                      ></textarea>

                      {error.content !== undefined && error.content !== "" ? (
                        <small className="text-danger mt-2">
                          {error.content}
                        </small>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>

                  {/*begin::Actions*/}
                  <div className="d-flex flex-row-fluid pt-3">
                    <button
                      type="button"
                      className="btn btn-sm btn-secondary me-3"
                      onClick={() => {
                        setError({});
                        setModal({ open: false, action: "", data: "" });
                      }}
                    >
                      Close
                    </button>

                    <button
                      onClick={addNotification}
                      type="button"
                      className="btn btn-primary btn-sm"
                      id="kt_modal_upgrade_plan_btn"
                    >
                      {/*begin::Indicator label*/}
                      <span className="indicator-label">Save</span>
                      {/*end::Indicator label*/}
                      {/*end::Indicator progress*/}
                    </button>
                  </div>
                  {/*end::Actions*/}
                </div>
                {/*end::Modal body*/}
              </div>
              {/*end::Modal content*/}
            </div>
            {/*end::Modal dialog*/}
          </div>
          {/*end::Modal - Add Notification*/}
          {/*begin::Modal - Edit Notification*/}
          <div
            className={
              modal?.open === true && modal?.action === "edit"
                ? "modal fade show d-block"
                : "modal fade"
            }
            tabIndex="-1"
            aria-hidden="true"
          >
            {/*begin::Modal dialog*/}
            <div className="modal-dialog modal-dialog-centered">
              {/*begin::Modal content*/}
              <div className="modal-content rounded">
                {/*begin::Modal header*/}
                <div className="modal-header">
                  {/*begin::Close*/}
                  <h4>Edit Notification</h4>
                  {/*end::Close*/}
                </div>
                {/*end::Modal header*/}

                {/*begin::Modal body*/}
                <div className="modal-body p-4">
                  <div className="row">
                    <div className="col-md-12">
                      <label className="form-label">Content</label>
                      <textarea
                        value={modal?.data?.content ?? ""}
                        onChange={(e) => {
                          setModal({
                            ...modal,
                            data: {
                              ...modal?.data,
                              content: e.target.value,
                            },
                          });
                          setError({ ...error, content: "" });
                        }}
                        autoComplete="off"
                        className="form-control"
                        placeholder="Enter notification content"
                      ></textarea>

                      {error.content !== undefined && error.content !== "" ? (
                        <small className="text-danger mt-2">
                          {error.content}
                        </small>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>

                  {/*begin::Actions*/}
                  <div className="d-flex flex-row-fluid pt-3">
                    <button
                      type="button"
                      className="btn btn-sm btn-secondary me-3"
                      onClick={() => {
                        setError({});
                        setModal({ open: false, action: "", data: "" });
                      }}
                    >
                      Close
                    </button>

                    <button
                      onClick={editNotification}
                      type="button"
                      className="btn btn-primary btn-sm"
                    >
                      {/*begin::Indicator label*/}
                      <span className="indicator-label">Save</span>
                      {/*end::Indicator label*/}
                      {/*end::Indicator progress*/}
                    </button>
                  </div>
                  {/*end::Actions*/}
                </div>
                {/*end::Modal body*/}
              </div>
              {/*end::Modal content*/}
            </div>
            {/*end::Modal dialog*/}
          </div>
          {/*end::Modal - Edit Notification*/}
          {/* start :: mark active */}
          <div
            className={
              modal?.open === true && modal?.action === "markActive"
                ? "modal fade show d-block"
                : "modal fade"
            }
            tabIndex={-1}
          >
            <div className="modal-dialog modal-dialog-centered modal-sm">
              <div className="modal-content text-center bg-success text-light">
                <div className="modal-header">
                  <h5 className="modal-title mx-auto text-light">
                    MARK ACTIVE
                  </h5>
                </div>
                <div className="modal-body">
                  <p className="h4 text-light">Are You Sure ?</p>
                </div>
                <div className="modal-footer justify-content-center">
                  <button
                    onClick={() => {
                      setModal({
                        open: false,
                        action: "",
                        data: "",
                      });
                    }}
                    type="button"
                    className="btn btn-light btn-sm"
                    data-bs-dismiss="modal"
                  >
                    No
                  </button>
                  <button
                    type="button"
                    className="btn btn-light btn-sm"
                    onClick={markActive}
                  >
                    Yes
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* end :: mark active */}
          {/* start :: mark inactive */}
          <div
            className={
              modal?.open === true && modal?.action === "markInactive"
                ? "modal fade show d-block"
                : "modal fade"
            }
            tabIndex={-1}
          >
            <div className="modal-dialog modal-dialog-centered modal-sm">
              <div className="modal-content text-center bg-warning text-light">
                <div className="modal-header">
                  <h5 className="modal-title mx-auto text-light">
                    MARK INACTIVE
                  </h5>
                </div>
                <div className="modal-body">
                  <p className="h4 text-light">Are You Sure ?</p>
                </div>
                <div className="modal-footer justify-content-center">
                  <button
                    onClick={() => {
                      setModal({
                        open: false,
                        action: "",
                        data: "",
                      });
                    }}
                    type="button"
                    className="btn btn-light btn-sm"
                    data-bs-dismiss="modal"
                  >
                    No
                  </button>
                  <button
                    type="button"
                    className="btn btn-light btn-sm"
                    onClick={markInactive}
                  >
                    Yes
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* end :: mark inactive */}
          {/* start :: delete */}
          <div
            className={
              modal?.open === true && modal?.action === "delete"
                ? "modal fade show d-block"
                : "modal fade"
            }
            tabIndex={-1}
          >
            <div className="modal-dialog modal-dialog-centered modal-sm">
              <div className="modal-content text-center bg-danger text-light">
                <div className="modal-header">
                  <h5 className="modal-title mx-auto text-light">DELETE</h5>
                </div>
                <div className="modal-body">
                  <p className="h4 text-light">Are You Sure ?</p>
                </div>
                <div className="modal-footer justify-content-center">
                  <button
                    onClick={() => {
                      setModal({
                        open: false,
                        action: "",
                        data: "",
                      });
                    }}
                    type="button"
                    className="btn btn-light btn-sm"
                    data-bs-dismiss="modal"
                  >
                    No
                  </button>
                  <button
                    type="button"
                    className="btn btn-light btn-sm"
                    onClick={deleteNotification}
                  >
                    Yes
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* end :: delete */}
          <Footer />
        </div>
        {/*end::Wrapper*/}
      </div>
      {/*end::Page*/}
    </div>
  );
};

export default AllNotifications;
